<template>
  <div class="recommending">
    <!-- <div class="banner">
      <span>专家委员会</span>
    </div> -->
    <div class="content">
      <div class="main_title">
        专家(排名不分先后)
      </div>
      <div class="textContent">
        <div class="lineTop"></div>
        <div class="plr24">
          <img src="@/assets/topIcon.png" class="topIconImg" alt="">
        </div>
        <div  class="lineTop"></div>
      </div>
      <div class="listContent">
        <div class="listHeader">
        <div class="t1">姓名</div>
        <div class="t2">单位</div>
        <div class="t3">领域背景</div>
        <div class="t4">职务</div>
      </div>
      <div class="listHeader" v-for="(item,index) in expertList" :key="index">
  <el-popover
    placement="top-end"
    width="500"
    close-delay="0"
    popper-class="showPopper"
    offset="200"
    trigger="hover">
    <div>
      <div class="popName">{{item.name}}</div>
      <div class="popContent">
        <div class="leftImg">
        <img :src="item.photos" class="headImg">
      </div>
      <div class="popRightContent">{{item.profile}}</div>
      </div>

    </div>
    
    <div slot="reference" class="referenceDiv">
      <div class="b1">{{item.name}}</div>
      <div class="b2">{{item.org_name}}</div>
      <div class="b3">{{item.area}}</div>
      <div class="b4">{{item.duties_name}}</div>
    </div>
  </el-popover>
</div>
      <!-- <div class="listHeader" v-for="(item,index) in tableData">
        <el-popover
    placement="top-start"
    title="标题"
    width="200"
    trigger="hover"
    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。">
        <div class="b1">{{item.name}}</div>
        <div class="b2">{{item.unit}}</div>
        <div class="b3">{{item.fieldBd}}</div>
        <div class="b4">{{item.position}}</div>
    </el-popover>

      </div> -->

      </div>

     
    </div>
  </div>
</template>

<script>

export default {
  name: "Recommending",
  data() {
    return {
      expertList: [],
      count: 0,
        filters: {
          pageSize: 9999,
          currPage: 1
        }
    }
  },
  mounted() {
    this.getExpertListList()
  },
  methods: {
    getExpertListList() {
      this.$API.getExpertList(this.filters).then(res => {
        // this.count = res.data.pageInfo.allRows;
        this.expertList = res.data.list;
      })
    }
  }
}
</script>
<style>
.popRightContent{
  padding-left: 10px;
}
.leftImg{
  border-right: 1px solid #e8e8e8;
  padding-right: 10px;
}
.showPopper{
  padding: 0 !important;
}
.popName{
  border-bottom: 1px solid #e8e8e8;
  padding: 10px;
}
.popContent{
  padding: 10px;
  display: flex;
}
.headImg{
 width: 143px;
 height: 196px;
  object-fit: contain;
}
</style>
<style scoped >


.referenceDiv{
  display: flex;
  width: 100%;
}
.b1{
  width: 8.3%;
  font-size: 14px;
  margin-left: 4.1%;
  color: #333;
}
.b2{
  width: 40.8%;
  font-size: 14px;
  color: #333;
  margin-left: 4.1%;
}
.b3{
  width: 21.6%;
  font-size: 14px;
  margin-left: 4.1%;
  color: #333;
}
.b4{
  width: 12.5%;
  font-size: 14px;
  margin-left: 4.1%;
  color: #333;
  text-align: center;
}
.t1{
  width: 12.5%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.t2{
  width: 45%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.t3{
  width: 17.6%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
}
.t4{
  width: 12.5%;
  text-align: center;
  font-size: 32px;
  color: #5c5c5c;
  margin-left: 8.3%;
}
.listHeader{
  display: flex;
  line-height: 38px;
  width: 100%;
  flex-wrap: wrap;
  span{
    width: 100%;
  }
}
.listContent{
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
}
.lineTop{
  width: 50%;
  border-top: 1px solid #e8e8e8;
}
.plr24{
  padding: 0 24px;
}
.textContent{
  width: 100%;
  margin: 20px 0;
  padding: 0 50px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.topIconImg{

}
.recommending {
  background: #f5f5f5;
}
.banner{
  position: relative;
    z-index: 2;
    overflow: hidden;
    background: #000;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    background-image: url('../../assets/tjdwBanner.png');
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    min-height: 350px;
    -webkit-align-items: center;
    align-items: center;
    span{
      color: #fff;
    letter-spacing: 5px;
    font-size: 50px;
    text-align: center;
    }
}
.content{
  width: 100%;
  max-width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;
    background-color: #fff;
    box-sizing: border-box;
}
.main_title{
  font-size: 32px;
    text-align: center;
    height: 40px;
    color: #5c5c5c;
}
</style>
